export const FLATTEN_BY_TOPIC = "flattenByTopic";
export const COUNT_BY_TOPIC = "countByTopic";
export const COUNT_BY_TYPE = "countByType";
export const COUNT_BY_TYPE_AND_TOPIC = "countByTypeAndTopic";
export const COUNT_BY_TOPIC_AND_TYPE = "countByTopicAndType";
export const GET_COUNT = "getCount";
export const GET_POST_TIMELINE_RELOAD = "getPostTimelineReload";
